import { useMemo } from 'react'
import { getSuggestSearch } from '@/apis/character'
import SearchIcon from 'Comps/svg/SearchIcon'
import useSWR from 'swr'

export const highlightMatch = (text: string, query: string) => {
  if (!query) return text
  const index = text.toLowerCase().indexOf(query.toLowerCase())
  if (index === -1) return text

  return (
    <span className="inline-flex">
      {text.slice(0, index)}
      <span className="text-red-500">
        {text.slice(index, index + query.length)}
      </span>
      {text.slice(index + query.length)}
    </span>
  )
}

const SuggestTags = ({
  query,
  setQuery,
  setLoading,
}: {
  query: string
  setQuery: (query: string) => void
  setLoading: (loading: boolean) => void
}) => {
  const { data: suggestList } = useSWR(
    query.trim()
      ? {
          endpoint: '/search/character/suggest',
          search: query.trim(),
        }
      : null,
    ({ search }) => getSuggestSearch(search),
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
      focusThrottleInterval: 10,
      dedupingInterval: 10 * 1000,
    }
  )

  const displaySuggestList = useMemo(() => {
    const searchText = query.trim()
    // 始终在开头插入原始 searchTerm，同时避免重复
    const suggestions = (suggestList ?? []).filter(
      (item) => item.toLowerCase() !== searchText.toLowerCase()
    )
    if (!searchText) return suggestions
    return [searchText, ...suggestions]
  }, [query, suggestList])

  return (
    <>
      {displaySuggestList.map((tag) => (
        <button
          className="flex w-[100%] items-center gap-2 border border-transparent py-2 pl-2 text-sm text-[rgba(255,255,255,0.7)] transition duration-500 hover:bg-white/10"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            setQuery(tag)
          }}
          key={tag}
        >
          <SearchIcon color="#634C54" />
          {highlightMatch(tag, query)}
        </button>
      ))}
    </>
  )
}

export default SuggestTags
